import { ScoredCreditCardProduct } from '@ilg-totallymoney/types'

import { getSanitisedCardName } from './getSanitisedCardName'

export function getCardMetadata(card?: ScoredCreditCardProduct) {
    if (card == null) {
        return {
            title: 'Card not found',
            description: 'The card cannot be found',
        }
    }

    return {
        title: `Check Eligibility for the ${card.name}`,
        description: `Compare features and see reviews for the ${card.name}. See your chances of acceptance for the ${card.name} before applying.`,
        canonical: `https://www.totallymoney.com/credit-cards/card/${getSanitisedCardName(
            card.name
        )}/`,
    }
}
